import React from "react";
import { usePendingWithholdingList } from "../../query/taxes/queries";
import { WSQueries } from "../../query/WSQuery";
import {
  MenuItemProps,
  WSElement,
  WSTable,
  WSTableColumn,
  WSText
} from "@wingspanhq/fe-component-library";
import { WithholdingTransactionType } from "@wingspanhq/bookkeeping/dist/lib/interfaces/withholdingTransaction";
import {
  PendingWithholdingStatus,
  PendingWithholdingSubType
} from "@wingspanhq/bookkeeping/dist/lib/interfaces/pendingWithholding";
import sortBy from "lodash/sortBy";
import { useUpdatePendingWithholding } from "../../query/taxes/mutations";
import { PendingTransactionStatus } from "@wingspanhq/bookkeeping/dist/lib/interfaces/pendingTransaction";

export const columns: Array<WSTableColumn> = [
  {
    config: {
      header: {
        text: "Description"
      },
      gridTemplateSizeMax: "1fr"
    },
    renderFunction: row => (
      <WSText.Label singleLine color="grey700">
        {row.data.title}
      </WSText.Label>
    )
  },
  {
    config: {
      header: {
        text: "Date"
      },
      justify: "end"
    },
    renderFunction: row => (
      <WSText.Label color="grey700" formatDate="monthDayYear">
        {row.data.date}
      </WSText.Label>
    )
  },
  {
    config: {
      header: {
        text: "Amount"
      },
      justify: "end"
    },
    renderFunction: row => (
      <WSText.Label color="grey700" formatMoney="taxes">
        {row.data.amount}
      </WSText.Label>
    )
  }
];

export const PendingWithholdingList: React.FC = () => {
  const qPendingWithholdingList = usePendingWithholdingList();
  const [
    updatePendingWithholding,
    updatePendingWithholdingMeta
  ] = useUpdatePendingWithholding();

  return (
    <WSQueries
      queries={{
        qPendingWithholdingList
      }}
    >
      {({ qPendingWithholdingList }) => {
        const tableData = sortBy(
          (qPendingWithholdingList.data || [])
            .filter(
              pendingWithholding =>
                pendingWithholding.status === PendingWithholdingStatus.Pending
            )
            .map(pendingWithholding => {
              return {
                data: {
                  source: pendingWithholding,
                  amount:
                    Math.abs(pendingWithholding.amount) *
                    (pendingWithholding.type ===
                      WithholdingTransactionType.TaxWithholding &&
                    pendingWithholding.subType ===
                      PendingWithholdingSubType.Deposit
                      ? 1
                      : -1),
                  title:
                    pendingWithholding.type ===
                      WithholdingTransactionType.TaxWithholding &&
                    pendingWithholding.subType ===
                      PendingWithholdingSubType.Withdraw
                      ? "Withdraw"
                      : pendingWithholding.type ===
                          WithholdingTransactionType.TaxWithholding &&
                        pendingWithholding.subType ===
                          PendingWithholdingSubType.Deposit
                      ? "Deposit"
                      : "Payment to IRS",
                  date: pendingWithholding.createdAt
                },
                id: pendingWithholding.pendingWithholdingId
              };
            }),
          "createdAt"
        ).reverse();

        if (!tableData.length) {
          return null;
        }

        return (
          <WSElement my="XL">
            <WSText.Heading3>Pending Transactions</WSText.Heading3>
            <WSTable
              mt="M"
              tableData={tableData}
              columns={columns}
              showHeader
              bottomMessage={!tableData.length && "No activity yet"}
              rowActions={item => {
                const {
                  id,
                  data: { source }
                } = item;
                const menuItems: MenuItemProps[] = [
                  {
                    icon: "close",
                    label: "Cancel",
                    onClick: async () => {
                      await updatePendingWithholding({
                        id: source.pendingWithholdingId,
                        status: PendingWithholdingStatus.Cancelled
                      });
                    }
                  }
                ];

                return menuItems;
              }}
            />
          </WSElement>
        );
      }}
    </WSQueries>
  );
};
